import { defineComponent, reactive, toRefs, computed, onMounted, onUnmounted, ref } from 'vue';

export const Combobox = defineComponent({
    name: 'Combobox',
    props: {
        list: {
            type: Array
        },
        modelValue: {
            type: String
        },
        fullValue: {
            type: Object
        },
        value: {
            type: String,
            default: null
        },
    },
    emits: {
        'update:modelValue': (val: any) => true,
        'update:fullValue': (val: any) => true,
        'fullValueChange': (val: any) => true,
        'valueChange': (val: any) => true,
    },
    setup(props, { emit, attrs }) {
        const root = ref(null);
        const state = reactive({
            isDropDownOpen: false,
            value: props.value,
        });

        const toggleDropDown = () => {
            state.isDropDownOpen = !state.isDropDownOpen;
        }

        const closeHandler = (e) => {
            if (!root.value.contains(e.target)) {
                state.isDropDownOpen = false;
            }
        }

        onMounted(() => {
            document.addEventListener('click', closeHandler)
        });

        onUnmounted(() => {
            document.removeEventListener('click', closeHandler)
        });

        const onInputHandler = (event) => {
            state.value = event.target.value;

            emit('fullValueChange', {
                value: state.value,
                source: 'input'
            });
            emit('update:modelValue', state.value);
        }

        const selectOfItemFromList = (event) => {
            if (!event || event.target.nodeName !== 'LI') {
                return;
            }

            const selectedTextValue: string = event.target.textContent;
            state.value = selectedTextValue

            emit('fullValueChange', {
                value: selectedTextValue,
                source: 'list'
            });

            emit('valueChange', selectedTextValue);
            state.isDropDownOpen = false;
        }

        return () => (
            <div ref={root} class="combobox">
                <input class="combobox__input" 
                    type="text"
                    value={state.value}
                    onInput={onInputHandler}
                />
                <button class="combobox__button" type="button" onClick={toggleDropDown}>
                    <span aria-hidden="true">
                        <svg class="combobox__button-icon" viewBox="0 0 24 24" role="img" aria-hidden="true">
                            <path d="M7,10L12,15L17,10H7Z"></path>
                        </svg>
                    </span>
                </button>
                <ul
                    class={`combobox__list ${state.isDropDownOpen ? 'combobox__list--active' : ''}`}
                    onClick={selectOfItemFromList}
                >
                    {
                        props.list.map((item) => {
                            return (
                                <li
                                    class="combobox__item"
                                    key={item.toString()}
                                >
                                    {item}
                                </li>
                            )
                        })
                    }
                </ul>
                <p>{props.modelValue}</p>
            </div>
        )
    }
})

export type Combobox = InstanceType<typeof Combobox>